module.exports = __webpack_public_path__ + "img/2-3.5ac62cc4.gif";